import { render, staticRenderFns } from "./HomeEarningPotencial.vue?vue&type=template&id=25870357&scoped=true"
import script from "./HomeEarningPotencial.js?vue&type=script&lang=js&external"
export * from "./HomeEarningPotencial.js?vue&type=script&lang=js&external"
import style0 from "./HomeEarningPotencial.scss?vue&type=style&index=0&id=25870357&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25870357",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
